/**
 * Small site-chrome banners shown above the report body.
 *
 * `AiStatusAlert` was removed in Feb 2026 — it was alarming paying
 * customers when the LLM had a transient hiccup, even though the
 * deterministic memo + dashboard remain unaffected. Operator status
 * is now only surfaced inside /admin (the `Totals` panel).
 */

export function BetaBanner() {
  return (
    <div
      className="no-print mb-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#5C665D] border border-[#E5E0D8] bg-white/70 rounded-full px-3 py-1.5"
      data-testid="beta-banner"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-[#C26D5C] animate-pulse" />
      Beta — your feedback shapes the next version
    </div>
  );
}
